module.exports = __webpack_public_path__ + "img/cinq.ab8b058e.png";